/* eslint-disable react/prop-types */ // TODO: add props
import { parsableDate } from 'core/utils/customPropTypes';
import { differenceInDays } from 'date-fns';
import { Pill, enums } from 'edrolo-ui';
import cx from 'classnames';
import s from './styles.scss';
import { useProfile } from 'edrolo/domains/profile';

function getDaysUntilExpiry(expiryDateISO) {
  const expiryDate = new Date(expiryDateISO);
  const currentDate = new Date();

  function normaliseDates() {
    expiryDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
  }
  normaliseDates();

  return differenceInDays(expiryDate, currentDate);
}

export const TrialFlag = ({ expirationDate, large = false }) => {
  const { profile } = useProfile(!!'immutable');

  return (
    <TrialFlagPresentational
      isTeacher={profile.get('is_teacher')}
      expirationDate={expirationDate}
      large={large}
    />
  );
};

export const TrialFlagPresentational = ({
  isTeacher,
  expirationDate,
  large,
}) => {
  const remainingDays = getDaysUntilExpiry(expirationDate);
  const daysToDisplay = remainingDays > 0 ? remainingDays : 'Last';
  const showCountDown = remainingDays <= 10;
  const expired = remainingDays < 0;

  const textLarge = `${daysToDisplay} ${
    daysToDisplay > 1 ? 'days' : 'day'
  } left in your trial.`;

  const textSmall = `${daysToDisplay} ${
    daysToDisplay > 1 ? 'days' : 'day'
  } left`;

  const countdown = large ? (
    <>
      <span className={s.text}>
        {expired ? 'Expired.' : textLarge}
        &nbsp;
      </span>
      {isTeacher && (
        <a href="mailto:trial@edrolo.com?subject=My%20Edrolo%20trial%20is%20about%20to%20expire">
          Talk to us.
        </a>
      )}
    </>
  ) : (
    <span className={cx(s.text, s.strong)}>
      {expired ? 'Expired' : textSmall}
    </span>
  );

  return (
    <div className={s.trialFlag}>
      <Pill color={enums.ColorHue.YELLOW}>Trial</Pill>
      {showCountDown && countdown}
    </div>
  );
};

TrialFlag.propTypes = {
  expirationDate: parsableDate,
};
